import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './phoneType';
import { themr } from 'react-css-themr';
import { PHONE_TYPES } from 'config/constants';

const PhoneType = ({ theme, source, value, onChange }) => {
  const types = source || PHONE_TYPES;
  const lastIndex = types.length - 1;
  return (
    <div className={theme.phoneTypes}>
      {
        types.map((type, index) => {
          const classnames = cx({
            [theme.selected]: type === value,
            [theme.phone]: true,
          });
          return (
            <span key={type}>
              <button className={classnames} onClick={() => onChange(type)}>{type}</button>
              {lastIndex !== index ? '/' : null}
            </span>
          );
        })
      }
    </div>
  );
};

PhoneType.propTypes = {
  theme: PropTypes.shape({
    phoneTypes: PropTypes.string,
    selected: PropTypes.string,
    phone: PropTypes.string,
  }),
  source: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default themr('PhoneType', styles)(PhoneType);



// WEBPACK FOOTER //
// ./client/app/shared/components/PhoneType/index.jsx